import React from 'react';
import { Section } from './ui/Section';
import { Moon, Clock, Home, PenLine } from 'lucide-react';
export function TheMechanism() {
  const steps = [{
    icon: Moon,
    title: 'Zone 1: Sleep-Survival (You)',
    desc: 'A 60–90 second downshift + basic needs so your body stops screaming.',
    time: '90 sec'
  }, {
    icon: Clock,
    title: 'Zone 2: Baby-Care (Next 2 Hours)',
    desc: 'Not the whole day. Just the next sequence.',
    time: '30 sec'
  }, {
    icon: Home,
    title: 'Zone 3: Home-Relief',
    desc: "Not 'clean the house.' One friction remover that lowers stress fastest.",
    time: '5-10 min'
  }];
  return <Section background="white" data-id="element-117">
      <div className="text-center mb-16" data-id="element-118">
        <h2 className="text-3xl md:text-4xl font-serif text-[#4A4238] mb-4" data-id="element-119">
          The 3-Zone Reset
        </h2>
        <p className="text-[#8C7E6E] text-lg" data-id="element-120">
          A 2–12 minute loop you can run in fragments.
        </p>
      </div>

      <div className="relative" data-id="element-121">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-[#E8E0D5] -z-10" data-id="element-122"></div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-123">
          {steps.map((step, index) => <div key={index} className="bg-[#FAF7F2] p-8 rounded-2xl relative group hover:-translate-y-1 transition-transform duration-300" data-id="element-124">
              <div className="w-16 h-16 mx-auto bg-white rounded-full border-4 border-[#E8E0D5] flex items-center justify-center text-[#7BA99E] mb-6 shadow-sm group-hover:border-[#7BA99E] transition-colors" data-id="element-125">
                <step.icon size={28} data-id="element-126" />
              </div>
              <div className="absolute top-6 right-6 text-xs font-bold text-[#8C7E6E] bg-[#E8E0D5] px-2 py-1 rounded-md" data-id="element-127">
                {step.time}
              </div>
              <h3 className="text-xl font-serif font-bold text-[#4A4238] mb-3" data-id="element-128">
                {step.title}
              </h3>
              <p className="text-[#4A4238]/80 leading-relaxed" data-id="element-129">{step.desc}</p>
            </div>)}
        </div>
      </div>

      <div className="mt-12 bg-[#E8E0D5]/30 p-6 rounded-xl flex items-center justify-center gap-4 text-[#4A4238]" data-id="element-130">
        <PenLine className="text-[#7BA99E]" data-id="element-131" />
        <p className="font-medium" data-id="element-132">
          Then: Close the Loop note so your brain stops spinning.
        </p>
      </div>
    </Section>;
}